import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { browserHistory } from 'react-router';
import ButtonDefault from '../../../utils/FormsComponents';
import {
  LongTextFieldTitle,
  SelectForm
} from '../../../utils_form/FormComponents';
import { required } from '../../../validation/FormValidation';
import findIcon from '../FileEdit/findIcon';
import ValidFile from '../../../utils/fileTypeFilter';
import DropZoneFile from '../../ToolsList/Components/DropZoneTools/DropZoneFile';
import IcoDocDrop from '../../../utils/img/ic-doc_newdoc.png';
import { addImageProcess } from '../../../utils/addImageProcess';

import * as SectionApi from '../../../../Logicas/SectionApi';
import * as S from './FileCreate.style';

export class FileCreate extends Component {
  constructor() {
    super();
    this.state = {
      sectionNames: [],
      selectedSectorId: '',
      file: [{ preview: null }],
      previewIcon: IcoDocDrop
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    const { sectionNameList } = this.props;

    if (!sectionNameList.length) {
      browserHistory.push('/tools/list');
      return null;
    }
  }

  setSectorId = (filedValue) => {
    delete filedValue.preventDefault;
    const name = Object.values(filedValue).join('');

    const selectedSector = this.props.sectionList.find(
      (section) => name === section.name
    );

    this.setState({ selectedSectorId: selectedSector.id });
  };

  async updateFile(file) {
    if (!ValidFile(file[0].type)) {
      this.props.showErroAlert(
        'Arquivo não suportado para cadastro nesta seção.'
      );
      return;
    }

    const fileIsImage = file[0].type.includes("image");
    const fileIsGif = file[0].type.includes("gif");

    let hasError = false;
    if(fileIsImage){
      const i = await addImageProcess(URL.createObjectURL(file[0])); 
      if(i.height > 2000 || i.width > 2000) {
        hasError = true;
        this.props.dispatchImageError();
      }
    }
    
    if(fileIsGif && (file[0].size / (1024*1024).toFixed(2)) > 20){
      hasError = true;
      this.props.dispatchGifError();
    }
    
    if(!hasError) {
      const extension = findIcon(file);
      this.setState({ file, previewIcon: extension });
    }
  }

  saveFile = (formValues) => {
    const { saveFileCreate } = this.props;
    const { selectedSectorId } = this.state;

    if (this.state.file[0].preview !== null) {
      formValues.file = this.state.file;
    }

    saveFileCreate(formValues, selectedSectorId);
  };

  render() {
    const { handleSubmit, sectionNameList } = this.props;

    return (
      <>
        <MuiThemeProvider>
          <S.ToolsComponentHeader>
            <S.ToolsComponentHeaderTitle>
              <S.ToolsComponentHeaderTitleValue>
                Novo arquivo
              </S.ToolsComponentHeaderTitleValue>
            </S.ToolsComponentHeaderTitle>
            <S.ToolsComponentHeaderButtons>
              <ButtonDefault
                label="Salvar"
                onClick={() =>
                  this.formRef.current.dispatchEvent(new Event('submit'))
                }
              />
            </S.ToolsComponentHeaderButtons>
          </S.ToolsComponentHeader>
          <S.FormContainer>
            <form onSubmit={handleSubmit(this.saveFile)} ref={this.formRef}>
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-12">
                        <LongTextFieldTitle
                          fullWidth={true}
                          name="name"
                          validations={[required]}
                          id="name"
                          label="Nome do arquivo*"
                          floatingLabelText="Digite ou cole o nome do recurso*"
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <SelectForm
                          name="section"
                          multiple={false}
                          label="Selecione uma seção"
                          validations={[required]}
                          elements={sectionNameList}
                          onChange={(e) => this.setSectorId(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <S.DropZone className="col md-4">
                    <S.DropZoneActions>
                      <S.DropZoneField>
                        <DropZoneFile
                          onDrop={(file) => this.updateFile(file)}
                          file={this.state.file}
                          previewIcon={this.state.previewIcon}
                          name="file"
                        />
                      </S.DropZoneField>
                      <S.DropZoneText>{this.state.file[0].name}</S.DropZoneText>
                      <S.DropZoneText>
                        Clique ou arraste arquivos para aqui
                      </S.DropZoneText>
                    </S.DropZoneActions>
                  </S.DropZone>
                </div>
              </div>
            </form>
          </S.FormContainer>
        </MuiThemeProvider>
      </>
    );
  }
}

let InitializeFromStateForm = reduxForm({
  form: 'createfile'
})(FileCreate);

const mapStateToProps = (state) => {
  return {
    initialValues: {
      kind: 'file'
    },
    sectionList: state.section.sectionList,
    sectionNameList: state.section.sectionNameList,
    alert: state.dialog
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getToolsList: async () => {
      await dispatch(SectionApi.getSectionList());
    },
    saveFileCreate: async (formValues, selectedSectorId) => {
      await dispatch(SectionApi.saveToolCreate(formValues, selectedSectorId));
    },
    showErroAlert: (message) =>
      dispatch({
        type: 'OPEN_ERROR',
        alert: { visible: true, message: message }
      }),
    dispatchImageError:()=>{
      dispatch({
        type: 'OPEN_ERROR',
        alert: {
          visible: true,
          message:"Não foi possível carregar a imagem",
          submessage:"O tamanho máximo para arquivos de imagem é de até 2000 x 2000 pixels.",
        }
      });
    },
    dispatchGifError:()=>{
      dispatch({
        type: 'OPEN_ERROR',
        alert: {
          visible: true,
          message:"Não é possível enviar o gif, recomendamos o upload de arquivos de gif com no máximo 20mb.",
        }
      });
    },
  };
};
InitializeFromStateForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(InitializeFromStateForm);
export default InitializeFromStateForm;
